function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M149.9,59h-11V38.5c0-4.1-3.4-7.5-7.5-7.5H68.1c-4.1,0-7.5,3.4-7.5,7.5V59h-11V38.5 c0-10.2,8.3-18.5,18.5-18.5h63.4c10.2,0,18.5,8.3,18.5,18.5L149.9,59L149.9,59z M120.1,88.3h59v11h-59V88.3z M20.5,88.3h59.4v11 H20.5V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M171,172.9H28.6c-8.9,0-16.2-7.2-16.2-16.2V64.4c0-8.9,7.2-16.2,16.2-16.2H171 c8.9,0,16.2,7.2,16.2,16.2v92.4C187.1,165.6,179.9,172.9,171,172.9L171,172.9z M28.6,59.2c-2.8,0-5.2,2.3-5.2,5.2v92.4 c0,2.9,2.3,5.2,5.2,5.2H171c2.8,0,5.2-2.3,5.2-5.2V64.4c0-2.9-2.3-5.2-5.2-5.2H28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M105.9,128.1H93.7c-7.9,0-14.3-6.4-14.3-14.3V89.3c0-7.9,6.4-14.3,14.3-14.3h12.2 c7.9,0,14.3,6.4,14.3,14.3v24.6C120.1,121.7,113.7,128.1,105.9,128.1L105.9,128.1z M93.7,85.9c-1.8,0-3.3,1.5-3.3,3.3v24.6 c0,1.8,1.5,3.3,3.3,3.3h12.2c1.8,0,3.3-1.5,3.3-3.3V89.3c0-1.8-1.5-3.3-3.3-3.3C105.9,85.9,93.7,85.9,93.7,85.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.720161075fdf8110f4bde25db8a792b8.svg";
export { ForwardRef as ReactComponent };